import React from "react";

export default function Attendance() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Attendance</h1>
      <p>View your personal attendance records.</p>

      <table className="w-full mt-4 border border-gray-300">
        <thead className="bg-gray-200">
          <tr>
            <th className="p-2 border">Date</th>
            <th className="p-2 border">Check-In</th>
            <th className="p-2 border">Check-Out</th>
            <th className="p-2 border">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="p-2 border">2025-12-01</td>
            <td className="p-2 border">09:00 AM</td>
            <td className="p-2 border">06:00 PM</td>
            <td className="p-2 border">Present</td>
          </tr>
          <tr>
            <td className="p-2 border">2025-12-02</td>
            <td className="p-2 border">09:15 AM</td>
            <td className="p-2 border">06:00 PM</td>
            <td className="p-2 border">Late</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
